/* eslint-disable @typescript-eslint/no-explicit-any */
import { Session, SupabaseClient, createClient } from '@supabase/supabase-js';

export interface SupabaseConfig {
  SUPABASE_URL: string;
  SUPABASE_KEY: string;
  IS_SERVER?: boolean;
}

export abstract class SupabaseCore {
  protected supabase: SupabaseClient;

  constructor(protected supabaseConfig: SupabaseConfig) {
    this.supabase = this.initClient(supabaseConfig);
  }

  initClient(config: SupabaseConfig) {
    if (!config.SUPABASE_URL || !config.SUPABASE_KEY) {
      throw new Error('Supabase configuration is missing!');
    }

    let authConfig = undefined as unknown;
    if (!config.IS_SERVER) {
      authConfig = {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'supabase.auth.token',
        storage: typeof localStorage !== 'undefined' ? localStorage : undefined,
        detectSessionInUrl: typeof window !== 'undefined',
        multiTab: true, // Enable multi-tab support
      };
    }

    return createClient(
      config.SUPABASE_URL,
      config.SUPABASE_KEY,
      authConfig || undefined
    );
  }

  getClient(): SupabaseClient {
    return this.supabase;
  }

  /**
   * Get the current authenticated user's session.
   * @returns The user's session or null if not authenticated.
   */
  async getSession(): Promise<Session | null> {
    // console.log('getSession()');
    const { data, error } = await this.supabase.auth.getSession();
    if (error) throw error;
    // console.log('getSession:', data.session);
    return data.session;
  }

  /**
   * Get the current authenticated user.
   */
  async getUser() {
    console.log('getUser()');
    try {
      const {
        data: { user },
        error,
      } = await this.supabase.auth.getUser();
      if (error) throw error;
      return user;
    } catch (error) {
      console.error('Error getting user:', (error as any).message);
      return null;
    }
  }
}
